import axios from "axios";
import {getField, updateField} from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        isLoadingApplicability: false,
        applicabilityCars: {
            families: {},
            meta: {},
            family: false,
            modifs: false,
            model: false
        },
        applicabilityCar: null,
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        async fetchApplicability1({commit, state, dispatch}, payload) {
            updateField(state, {path: 'isLoadingApplicability', value: true});
            updateField(state, {path: 'applicabilityCars', value: null});
            return await axios.get(this._vm.$apiURL +`/applicability1`, {
                params: {
                    part_code: payload.part_code
                }
            })
                .then((response) => {
                    if(response.data && response.data.length){
                        updateField(state, {path: 'applicabilityCars', value: response.data});
                    }
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root: true});
                })
                .finally(()=>{
                    updateField(state, {path: 'isLoadingApplicability', value: false});
                })
        },
    }
}
